import { render, staticRenderFns } from "./SubstituteTeachingManager.vue?vue&type=template&id=b913a546"
import script from "./SubstituteTeachingManager.vue?vue&type=script&lang=js"
export * from "./SubstituteTeachingManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports